import {
  GetHiringStagesDocument,
  UpdateHiringPhasesPositionDocument,
  UpdateHiringPhasesPositionMutation,
  UpdatePositionsAtsHiringPhaseNewPositionsInput,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateHiringPhasesPosition = () => {
  const [updatePositionsAtsHiringPhase, { loading }] = useMutation(
    UpdateHiringPhasesPositionDocument,
    {
      extractorFn: (data: UpdateHiringPhasesPositionMutation) =>
        data.atsMutations.updatePositionsAtsHiringPhase,
    }
  )

  return {
    loading,
    updatePositions(newPositions: [UpdatePositionsAtsHiringPhaseNewPositionsInput]) {
      return updatePositionsAtsHiringPhase({
        variables: { newPositions },
        refetchQueries: [GetHiringStagesDocument],
      })
    },
  }
}
